import { useState } from "react";
import ReportSummary from "../../sections/reportDashboard/reportSummary/ReportSummary";
import { TopNav } from "../../components/reportDashboard/common/TopNav";
import Flights from "../../sections/reportDashboard/flights/Flights";
import { Hotels } from "../../sections/reportDashboard/hotels/Hotels";
import { Insurance } from "../../sections/reportDashboard/insurance/Insurance";
import { Tours } from "../../sections/reportDashboard/tours/Tours";
import { Packages } from "../../sections/reportDashboard/packages/Packages";
import { Subscriptions } from "../../sections/reportDashboard/subscribtions/Subcribtions";
import { PostTicketing } from "../../sections/reportDashboard/postTicketing/PostTicketing";
import { TravX } from "../../sections/reportDashboard/travx/Travx";
import { Api } from "../../sections/reportDashboard/api/Api";
import { Agents } from "../../sections/reportDashboard/agents/Agents";
import { PageWrapper } from "../../components/reportDashboard/common/PageWrapper";
import Wallet from "../../sections/reportDashboard/wallet/Wallet";

export default function ReportDashboard() {
  const [activeView, setActiveView] = useState("summary");

  const renderView = () => {
    switch (activeView) {
      case "summary":
        return <ReportSummary />;
      case "flights":
        return <Flights onViewChange={setActiveView} />;
      case "hotels":
        return <Hotels />;
      case "tours":
        return <Tours />;
      case "packages":
        return <Packages />;
      case "subscriptions":
        return <Subscriptions />;
      // case "post-ticketing":
      //   return <PostTicketing />;
      case "travx":
        return <TravX />;
      // case "api":
      //   return <Api />;
      case "wallet":
        return <Wallet />;
      case "insurance":
        return <Insurance />;
      // case "agents":
      //   return <Agents />;
      default:
        return (
          <div className="flex items-center justify-center h-full">
            <div className="text-center">
              <h2 className="text-[#1A1A1A] mb-2">Coming Soon</h2>
              <p className="text-[#6B7280]">This view is under development</p>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="flex flex-col h-screen bg-[#F8F9FC]">
      <TopNav activeView={activeView} onViewChange={setActiveView} />
      <main className="flex-1 overflow-y-auto">
        <div className="max-w-[1440px] ">
          <PageWrapper>{renderView()}</PageWrapper>
        </div>
      </main>
    </div>
  );
}
